import Vue from 'vue'

import './styles/quasar.sass'
import iconSet from 'quasar/icon-set/mdi-v4.js'
import langEs from 'quasar/lang/es.js'
import langEn from 'quasar/lang/en-us.js'
import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/mdi-v4/mdi-v4.css'
import Quasar from 'quasar/src/vue-plugin.js';import Loading from 'quasar/src/plugins/Loading.js';import Notify from 'quasar/src/plugins/Notify.js';import Dialog from 'quasar/src/plugins/Dialog.js';

let currentLang = langEs
if (typeof window !== 'undefined') {
  const locale = window.localStorage.getItem('app-locale')
  if (locale === 'en') {
    currentLang = langEn
  }
}

Vue.use(Quasar, {
  config: {
    primary: '#fff'
  },
  plugins: {
    Loading, Notify, Dialog
  },
  lang: currentLang,
  iconSet: iconSet
})